import useDeleteNotifications from './useDeleteNotifications';

export default useDeleteNotifications;
export * from './useDeleteNotifications';
